export const ROLE_ADMIN = 1
export const ROLE_EVENT_MANAGER = 2
export const ROLE_GAME_MASTER = 3
export const ROLE_SUPERADMIN = 4

/** Roles that inherit full org-admin capabilities (includes superadmin). */
export const ADMIN_ROLES = [ROLE_ADMIN, ROLE_SUPERADMIN] as const

export function isAdminRole(rol: number | string | null | undefined): boolean {
	const value = Number(rol)
	return value === ROLE_ADMIN || value === ROLE_SUPERADMIN
}

export function isSuperadminRole(rol: number | string | null | undefined): boolean {
	return Number(rol) === ROLE_SUPERADMIN
}

export function isGameMasterRole(rol: number | string | null | undefined): boolean {
	return Number(rol) === ROLE_GAME_MASTER
}
